import { useState } from 'react';

import { useAppDispatch } from 'segments/hooks';

import { changeCourtsActiveModal } from 'features/courts';

import { CourtsModals, CourtsTablePage } from 'widgets/courts';

const Courts = () => {
  const dispatch = useAppDispatch();
  const [selectedCourtId, setSelectedCourtId] = useState<number>();

  const handleCreateClick = () => {
    dispatch(changeCourtsActiveModal('create-court-modal'));
  };

  const handleEditClick = (id: number) => {
    setSelectedCourtId(id);
    dispatch(changeCourtsActiveModal('edit-court-modal'));
  };

  return (
    <div>
      <CourtsTablePage
        handleCreateClick={handleCreateClick}
        handleEditClick={handleEditClick}
      />
      <CourtsModals
        selectedCourtId={selectedCourtId}
      />
    </div>
  );
};

export default Courts;
